import { render } from "./dadostecnicos.vue?vue&type=template&id=46d871e9&scoped=true"
import script from "./dadostecnicos.vue?vue&type=script&lang=js"
export * from "./dadostecnicos.vue?vue&type=script&lang=js"

import "./dadostecnicos.vue?vue&type=style&index=0&id=46d871e9&scoped=true&lang=scss"

import exportComponent from "/var/www/amee/gdaudit-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d871e9"]])

export default __exports__